// Template element content is rendered into a document fragment. By
// default, morphdom considers two fragments identical even if their
// content differs - Nick, Sat Apr 20 2024
export function morphdomMorphTemplate(fromElement, toElement) {
  const node = toElement.cloneNode(true)
  fromElement.replaceWith(node)
}
